var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from '../../styled';
import alertTheme from '../../themes/alert';
import { Alert as AlertIcon, Risk, CircleTick, Cross } from '../icons/solid';
const Container = styled.div `
  box-sizing: border-box;
  display: ${isShow => (isShow ? 'flex' : 'none')};
  border-radius: 6px;
  padding: 1rem;
  color: ${({ theme, alertKey }) => theme.colors[theme.alert.types[alertKey].color]};
  background-color: ${({ theme, alertKey }) => theme.colors[theme.alert.types[alertKey].backgroundColor]};
  border: 0.0625rem solid
    ${({ theme, alertKey }) => theme.colors[theme.alert.types[alertKey].borderColor]};
`;
const IconWrapper = styled.div `
  flex-direction: column;
  padding-right: 0.25rem;
  line-height: 1.7;
`;
const Body = styled.div `
  flex-direction: column;
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.6;
`;
const CloseButton = styled.div `
  flex-direction: column;
  padding: 0.25rem 0 0 0.25rem;
  line-height: 0;
  > div {
    cursor: pointer;
  }
`;
const IconMap = {
    success: React.createElement(CircleTick, { size: "SMALL", color: alertTheme.types.success.color }),
    destructive: React.createElement(Risk, { size: "SMALL", color: alertTheme.types.destructive.color }),
    warning: React.createElement(AlertIcon, { size: "SMALL", color: alertTheme.types.warning.color }),
    information: (React.createElement(AlertIcon, { size: "SMALL", color: alertTheme.types.information.color })),
};
const alertGenerator = (alertKey) => (_a) => {
    var { isShow = true, showCloseButton = false, Icon, children } = _a, restProps = __rest(_a, ["isShow", "showCloseButton", "Icon", "children"]);
    const [isClosed, setIsClosed] = useState(false);
    const icon = IconMap[alertKey];
    return isShow && !isClosed ? (React.createElement(Container, Object.assign({}, restProps, { alertKey: alertKey }),
        React.createElement(IconWrapper, null, Icon ? (React.createElement(Icon, { size: "LARGE", color: alertTheme.types[alertKey].color })) : (icon)),
        React.createElement(Body, null, children),
        showCloseButton && (React.createElement(CloseButton, { alertKey: alertKey },
            React.createElement("div", { onClick: () => setIsClosed(true), role: "presentation" },
                React.createElement(Cross, { size: "SMALL", color: alertTheme.types[alertKey].color })))))) : null;
};
export const Success = alertGenerator('success');
export const Destructive = alertGenerator('destructive');
export const Warning = alertGenerator('warning');
export const Information = alertGenerator('information');
//# sourceMappingURL=Alert.js.map